import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import DiscountForm from "./DiscountForm";
import Discount, { newDiscount } from "../../models/discount";

interface DiscountUpdateModalProps {
  show: boolean;
  discount?: Discount;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const DiscountUpdateModal: React.FC<DiscountUpdateModalProps> = ({
  show,
  discount,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialDiscount, setInitialDiscount] = useState<Discount>(
    discount ? discount : newDiscount()
  );

  const modalTitle = discount
    ? `Editar Descuento: ${discount.name}`
    : `Crear Descuento nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialDiscount(newDiscount());
    onCancel();
  };
  useEffect(() => {
    setInitialDiscount(discount ? discount : newDiscount());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discount]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <DiscountForm
            initialDiscount={initialDiscount}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default DiscountUpdateModal;
